import { mapState } from 'vuex';

export const avatarGroupSizes = {
  1: 19,
  2: 4,
};

export const defaultGroupAvatars = {
  1: '/static/images/avatars/set1/avatar_13.png',
  2: '/static/images/avatars/set2/avatar_01.png',
};

const avatarMixin = {
  computed: {
    ...mapState('common', {
      avatarMixinGroupId: 'avatarGrouping',
    }),
    avatarMixinGroupSize () {
      return avatarGroupSizes[this.avatarMixinGroupId] || 0;
    },
    avatarMixinDefaultGroupAvatar () {
      return defaultGroupAvatars[this.avatarMixinGroupId] || '';
    },
  },
};

export default avatarMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/avatar.js